module.exports = __webpack_public_path__ + "static/media/banner.d390677e.jpg";